import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installGlobalErrorReporter, BUILD_ID } from "./lib/errorReporter";

installGlobalErrorReporter();
// eslint-disable-next-line no-console
console.info("[build]", BUILD_ID);

// Recupera automaticamente de bundles antigos em cache após um novo deploy
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  try {
    if (sessionStorage.getItem("chunk-reload-attempt")) return;
    sessionStorage.setItem("chunk-reload-attempt", "1");
  } catch {
    /* noop */
  }
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);